'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-possible-prototype.js
// module id = 324
// module chunks = 0